import { Cart } from "@apis/model/mini-cart";

export interface AddToCartEvent {
  cart: Cart;
  preventEntryMerge?: boolean;
  productCode: string;
}

export enum UpdateMode {
  MINUS = "MINUS",
  PLUS = "PLUS",
  INPUT = "INPUT",
}

export interface QuantityUpdate {
  productCode: string;
  quantity: number;
}
